export default function TelegramIcon() {
    return (
        <svg width="30" height="29" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.02249 7.42009L4.81076 10.5141C5.11369 10.5141 5.24489 10.3789 5.40222 10.2166L6.82249 8.80642L9.76542 11.0455C10.3052 11.358 10.6854 11.1934 10.831 10.5296L12.7628 1.12567L12.7633 1.12512C12.9345 0.296204 12.4748 -0.0279368 11.9489 0.175413L0.594228 4.69177C-0.180705 5.00428 -0.168972 5.45309 0.462494 5.65644L3.36543 6.5945L10.1084 2.21113C10.4257 1.99282 10.7142 2.11361 10.4769 2.33192L5.02249 7.42009Z" fill="white" />
        </svg>
    )
}
